import { Draft, produce } from 'immer';

import {
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_BY_DRAFT_SUCCESS,
  CONTRACT_SETUP_PARTICIPANT_MESSAGE_CHANGE,
  CONTRACT_SETUP_PARTICIPANT_REMOVE,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';

export interface ContractSetupMessageState {
  [participantId: string]: string;
}

const initialState: ContractSetupMessageState = {};

const reducer = produce(
  (
    draft: Draft<ContractSetupMessageState>,
    action: ContractSetupAction
  ): ContractSetupMessageState => {
    switch (action.type) {
      case CONTRACT_SETUP_ALL_STATE_CLEAR:
        return initialState;
      case CONTRACT_SETUP_PARTICIPANT_MESSAGE_CHANGE: {
        const { participantId, message } = action.payload;
        draft[participantId] = message;
        return draft;
      }
      case CONTRACT_SETUP_PARTICIPANT_REMOVE: {
        const { participantId } = action.payload;
        if (participantId in draft) {
          delete draft[participantId];
        }
        return draft;
      }
      case CONTRACT_SETUP_BY_DRAFT_SUCCESS: {
        action.payload.participants.forEach(({ id, requesterMessage }) => {
          draft[id] = requesterMessage;
        });

        return draft;
      }
      default:
        return draft;
    }
  },
  initialState
);

export default reducer;
